module.exports = require('./colorbrewer.js');



//////////////////
// WEBPACK FOOTER
// ./~/colorbrewer/index.js
// module id = 94
// module chunks = 0